/**
 * @author bly & lifei & gll
 * 功能：供应商管理
 */

import { Service } from '@/tools'

export class SupplierService<T extends TCustomer.Supplier> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCustomer.Supplier}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 分批查询所有供应商
  // /api/customer/supplier/v1/allSuppliers
  allSuppliers = <K extends T['ApiAllSuppliers']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAllSuppliers', data)

  // 供应商列表
  // /api/customer/supplier/v1/supplierPage
  supplierPage = <K extends T['ApiSupplierPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSupplierPage', data)

  // 新增供应商
  // /api/customer/supplier/v1/addSupplier
  addSupplier = <K extends T['ApiAddSupplier']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddSupplier', data)

  //  编辑供应商
  // /api/customer/supplier/v1/updateSupplier
  updateSupplier = <K extends T['ApiUpdateSupplier']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateSupplier', data)

  //  查看供应商
  // /api/customer/supplier/v1/supplierDetail
  supplierDetail = <K extends T['ApiSupplierDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSupplierDetail', data)

  //  NC编码
  // /api/customer/supplier/v1/supplierNcList
  supplierNcList = <K extends T['ApiSupplierNcList']>(): Promise<K['res']> => this.post2('v1/ApiSupplierNcList')

  //  内部供应商组织公司去重
  // /api/customer/supplier/v1/checkInnerSupplier
  checkInnerSupplier = <K extends T['ApiCheckInnerSupplier']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckInnerSupplier', data)

  // 虚拟供应商公司名去重
  // /api/customer/supplier/v1/checkVirtualSupplier
  checkVirtualSupplier = <K extends T['ApiCheckVirtualSupplier']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckVirtualSupplier', data)

  //外部供应商统一社会信用代码去重提醒
  // /api/customer/supplier/v1/checkOuterSupplier
  checkOuterSupplier = <K extends T['ApiCheckOuterSupplier']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckOuterSupplier', data)

  // //供应商 清盘/撤销清盘
  // /api/customer/supplier/v1/liquidateAndRevocate
  liquidateAndRevocate = <K extends T['ApiLiquidateAndRevocate']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiLiquidateAndRevocate', data, '操作成功')

  //供应商 清盘/撤销清盘页面回显
  //  /api/customer/supplier/v1/liquidatePage
  liquidatePage = <K extends T['ApiLiquidatePage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiLiquidatePage', data)

  //供应商 清盘执行
  //  /api/customer/supplier/v1/liquidateExecute
  liquidateExecute = <K extends T['ApiLiquidateExecute']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiLiquidateExecute', data)

  //供应商 清盘执行页面回显
  //  /api/customer/supplier/v1/liquidateExecutePage
  liquidateExecutePage = <K extends T['ApiLiquidateExecutePage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiLiquidateExecutePage', data)

  // 客户编码去重：/api/customer/customer/v1/checkCustomerCode
  checkSupplierCode = <K extends T['ApiCheckSupplierCode']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckSupplierCode', data)

  //供应商冻结：/api/customer/supplier/v1/frozen
  frozen = <K extends T['ApiFrozen']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFrozen', data)

  //供应商同步wms: /api/customer/supplier/v1/supplierSynchronizeWms
  supplierSynchronizeWms = <K extends T['ApiSupplierSynchronizeWms']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSupplierSynchronizeWms', data)
  //供应商同步吉客云 : /api/customer/supplier/v1/supplierSynchronizeJkyun
  supplierSynchronizeJkyun = <K extends T['ApiSupplierSynchronizeJkyun']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSupplierSynchronizeJkyun', data)
}
